import React from 'react';
import { Container } from '@mui/material';
import Grid from '@mui/material/Grid';
import { CustomerIdentityPanel } from '@/components/iem/identity/CustomerIdentityPanel';
import { MainContentTabs } from '@/components/iem/panels/MainContentTabs';
import { usePageTitle } from '@/hooks/usePageTitle';
import { useModuleConfig } from '@/hooks/queries/admin/useModuleConfig';
import type { IemModuleConfig } from '@/types/moduleConfig';
import { useAuth } from '@/hooks/useAuth';

export const FrontWindowPage: React.FC = () => {
  const { config } = useModuleConfig<IemModuleConfig>('iem');
  const { isServiceMember } = useAuth();
  const pageTitle = isServiceMember
    ? config.features.front_window.menu_label_service_member || 'Front Window'
    : config.features.front_window.menu_label || 'Front Window';
  usePageTitle(pageTitle);

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Grid container spacing={3}>
        {/* Left Column: Customer Identity */}
        <Grid size={{ xs: 12, md: 2 }}>
          <CustomerIdentityPanel />
        </Grid>

        {/* Right Column: Main Content Tabs */}
        <Grid size={{ xs: 12, md: 10 }}>
          <MainContentTabs />
        </Grid>
      </Grid>
    </Container>
  );
};
